import React from 'react'

import { JoinToSpeakRole } from '../role'

import type { JoinToSpeakProviderProps } from './types'
import { JoinToSpeakHostProvider } from './host'
import { JoinToSpeakSpeakerProvider } from './speaker'
import { JoinToSpeakAudienceProvider } from './audience'

/* eslint-disable react/destructuring-assignment */
const JoinToSpeakProvider = (props: JoinToSpeakProviderProps) => {
  const { isEnabled = true, children, role } = props

  if (!isEnabled) {
    return <>{children}</>
  }

  switch (role) {
    case JoinToSpeakRole.Host:
      return <JoinToSpeakHostProvider>{children}</JoinToSpeakHostProvider>
    case JoinToSpeakRole.Speaker:
      return (
        <JoinToSpeakSpeakerProvider sessionId={props.sessionId}>
          {children}
        </JoinToSpeakSpeakerProvider>
      )
    case JoinToSpeakRole.Audience:
      return (
        <JoinToSpeakAudienceProvider
          sessionId={props.sessionId}
          token={props.token}
        >
          {children}
        </JoinToSpeakAudienceProvider>
      )
    default:
      return null
  }
}

export { JoinToSpeakProvider }
